import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    Form,
    Row,
    Col,
    Button,
    Input,
    Select,
    Table,
    Popconfirm,
    message,
    Modal,
    Typography,
    Upload,
    Tooltip,
    Space,
    Checkbox
} from 'antd';
import { expenseOrderEditRequest, expenseDeleteRequest, settleMerchantListRequest } from '../../../api/api'
import { useCallbackState } from '../../../util/useCallbackState'
import host from '../../../util/host';
import SubLedgerRule from '../subLedgerRule/index';
import Amount from '../amount/index';
import Type from '../type/index'
import './style.less'
// import Checkbox from 'antd/lib/checkbox/Checkbox';
const { Option } = Select;
const { Title } = Typography;
const layout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 16 },
};
const CostAdd = () => {
    const [lists, setLists] = useState([])
    const [merchantList, setMerchantList] = useState([])
    const [currentPage, setCurrentPage] = useCallbackState(1)
    const [pageNum, setPageNum] = useCallbackState(10)
    const [total, setTotal] = useState(0)
    const [init, setInit] = useState(true)
    const [mySwitch, setMySwitch] = useState(localStorage.state == "1" ? true : false)
    const [detailVisible, setDetailVisible] = useState(false);
    const [row, setRow] = useState(null)
    const [shMerchantList, setShMerchantList] = useState([])
    const [aipv, setAipv] = useState(Number)
    const [arr, setArr] = useState(Array)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectAll, setSelectAll] = useState(false)
    const [excludeOrderNos, setExcludeOrderNos] = useState(Array)
    const [params, setParams] = useState(null)
    const [typeVisible, setTypeVisible] = useState(false)
    const [amountVisible, setAmountVisible] = useState(false)
    const navigate = useNavigate()
    const { search } = useLocation()

    useEffect(() => {
        skSettleMerchantList();
        if (init) {
            settleMerchantList();

        }
    }, [currentPage, pageNum])


    const columns = [
        {
            title: '分账类型',
            dataIndex: 'shareType',
            key: 'shareType',
            render: (text, row) => (
                <div>
                    {row.shareType == 0 ? '按订单' : ''}
                    {row.shareType == 1 ? '按金额' : ''}
                </div>
            ),
        },
        {
            title: '单据类型',
            dataIndex: 'typeNames',
            key: 'typeNames',
            render: (text, row) => {
                return (
                    <div>
                        {
                            row.businessTypeNosErrorMsg == "" ?
                                <div>
                                    {row.typeNames}
                                </div> :
                                <div>
                                    <div>
                                        {row.typeNames} <div style={{ color: 'red' }}>{row.businessTypeNosErrorMsg}</div>
                                    </div>
                                </div>
                        }
                    </div>
                )

            }

        },
        {
            title: '收支类型',
            dataIndex: 'expenseReceiptType',
            key: 'expenseReceiptType',
            render: (text, row) => (
                <>
                    {
                        row.shareType == 1 ?
                            <div>定额</div>
                            :
                            <div>
                                {row.expenseReceiptType == 0 ? '定额' : ''}
                                {row.expenseReceiptType == 1 ? '比例' : ''}
                                {row.expenseReceiptType == 2 ? '区间比例' : ''}
                                {row.expenseReceiptType == 3 ? '区间定额' : ''}
                            </div>
                    }

                </>

            ),
        },
        {
            title: '单据金额',
            dataIndex: 'expensePaySectionJson',
            key: 'expensePaySectionJson',
            render: (text, row) => (
                <>
                    {
                        row.shareType == 0 ?
                            <div>
                                {
                                    row.expenseReceiptType == 2 || row.expenseReceiptType == 3 ?
                                        <div>
                                            {
                                                JSON.parse(row.expensePaySectionJson).map((v, index) => {
                                                    return <div>
                                                        {row.expenseReceiptType == 2 ? '比例:' : '区间:'}{v.startPrice}~{v.endPrice}/{v.number}{row.expenseReceiptType == 2 ? '%' : '元'}
                                                    </div>
                                                })
                                            }


                                        </div>
                                        :
                                        <div>{row.expenseReceiptType == 0 ? '￥' : null}{row.expensePaySectionJson}{row.expenseReceiptType == 1 ? '%' : null} </div>
                                }

                            </div>
                            :
                            <div>
                                {row.shareMoneyType == 0 ? '不足不扣' : '补偿扣款'}/￥{row.expensePaySectionJson}
                            </div>
                    }

                </>

            ),
        },
        {
            title: '结算周期',
            dataIndex: 'settleType',
            key: 'settleType',
            render: (text, row) => (
                <div>
                    {
                        row.settleType ?
                            <div>
                                {
                                    row.settleType == 1 ?
                                        <div>
                                            每日:{row.settleValue}号
                                        </div> : null
                                }
                                {
                                    row.settleType == 2 ?
                                        <div>
                                            每周:星期{row.settleValue}
                                        </div> : null
                                }
                                {
                                    row.settleType == 3 ?
                                        <div>
                                            每约:{row.settleValue}号
                                        </div> : null
                                }
                            </div> :
                            <div>--</div>
                    }


                </div>
            ),
        },
        {
            title: '收入机构',
            dataIndex: 'payeeMerchantNames',
            key: 'payeeMerchantNames',
            width: 200,
            render: (text, row) => (
                <div className='ellipsis'>
                    {
                        !row.payeeMerchantCodesErrorMsg ?
                            <div>
                                {
                                    row.payeeMerchantNames && row.payeeMerchantNames
                                }
                            </div> :
                            <div>
                                <div>
                                    {row.payeeMerchantNames} <div style={{ color: 'red' }}>{row.payeeMerchantCodesErrorMsg}</div>
                                </div>
                            </div>
                    }
                </div>
            ),
        },
        {
            title: '收入账户',
            dataIndex: 'accountType',
            key: 'accountType',
            render: (text, row) => (
                <div>
                    {
                        !row.accountTypeErrorMsg ?
                            <div>
                                {row.accountType == 0 ? '店铺待结算余额' : ''}
                                {row.accountType == 4 ? '钱包待结算余额' : ''}
                                {row.accountType == 1 ? '店铺余额' : ''}
                                {row.accountType == 2 ? '钱包余额' : ''}
                                {row.accountType == 7 ? '营销余额待结算' : ''}
                                {row.accountType == 8 ? '营销余额' : ''}
                            </div> :
                            <div>
                                <div>
                                    {row.accountType == 0 ? '店铺待结算余额' : ''}
                                    {row.accountType == 4 ? '钱包待结算余额' : ''}
                                    {row.accountType == 1 ? '店铺余额' : ''}
                                    {row.accountType == 2 ? '钱包余额' : ''}
                                    {row.accountType == 7 ? '营销余额待结算' : ''}
                                    {row.accountType == 8 ? '营销余额' : ''}
                                    <div style={{ color: 'red' }}>{row.accountTypeErrorMsg}</div>

                                </div>
                            </div>
                    }
                </div>
            ),
        },
        {
            title: '单据有效期',
            dataIndex: 'date',
            key: 'date',
            render: (text, row) => (
                <>
                    {
                        row.expireStartTimeErrorMsg == null ?
                            <div>
                                {
                                    row.expireType == 0 ?
                                        <div>
                                            {row.expireStartTime}-{row.expireEndTime}
                                        </div> : null
                                }
                                {
                                    row.expireType == 1 ?
                                        <div>
                                            {row.expireStartTime}-长期有效
                                        </div> : null
                                }
                                {
                                    row.expireType == 2 ?
                                        <div>
                                            {row.expireStartTime}-一次性费用
                                        </div> : null
                                }

                            </div>
                            :
                            <div>
                                <div>
                                    {
                                        row.expireType == 0 ?
                                            <div>
                                                {row.expireStartTime}-{row.expireEndTime}
                                            </div> : null
                                    }
                                    {
                                        row.expireType == 1 ?
                                            <div>
                                                {row.expireStartTime}-长期有效
                                            </div> : null
                                    }
                                    {
                                        row.expireType == 2 ?
                                            <div>
                                                {row.expireStartTime}-一次性费用
                                            </div> : null
                                    }

                                </div>
                                <div style={{ color: 'red' }}>
                                    {row.expireStartTimeErrorMsg}
                                </div>
                            </div>
                    }

                </>

            ),
        },
        {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 120,
            align: 'right',
            render: (text, row) => (
                <div style={{ textAlign: 'rigth' }}>
                    <Popconfirm
                        title="是否确认删除?"
                        onConfirm={() => {
                            deleteFuc(row)
                        }}
                        onCancel={() => {

                        }}
                        okText="是"
                        cancelText="否"
                    >
                        <span style={{ color: '#165BD4', cursor: 'pointer', marginLeft: 10 }}>删除</span>
                    </Popconfirm>
                    {
                        <span style={{ color: '#165BD4', cursor: 'pointer', marginLeft: 10 }} onClick={() => {
                            row.payerMerchantCodesArry = form.getFieldValue().payerMerchantCodesArry
                            setParams(row);
                            setDetailVisible(true)
                        }}>编辑</span>
                    }
                    {/* <Link style={{ marginLeft: 10 }} to="/ws/bills/detail" > </Link> */}
                    {
                        localStorage.hxState == 'true' && row.expenseStatus == 1 ?
                            <Popconfirm
                                title="是否确认停用?"
                                onConfirm={() => {
                                    expenseDelete(row)
                                }}
                                onCancel={() => {

                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <a style={{ marginLeft: 10 }} href="#">停用</a>
                            </Popconfirm> : ''
                    }
                </div>





            ),

        },
    ];


    const deleteFuc = (row) => {
        console.log(row);

        let index = lists.findIndex((v) => { return v.id == row.id })
        lists.splice(index, 1)
        arr.splice(index, 1)
        setLists([...lists])
        setArr([...arr])
    }
    const detailHandleOk = () => {
        setDetailVisible(false);
    };

    const detailhandleCancel = () => {
        setDetailVisible(false);
    };
    const [form] = Form.useForm();


    const settleMerchantList = () => {
        (async _ => {
            return await settleMerchantListRequest({
                merchantCode: localStorage.merchantCode,
                superMerchantCode: localStorage.appid,
            });
        })().then(res => {
            if (res.code == 0) {
                setInit(false)
                setMerchantList(res.data)
            } else {

            }
        });
    }
    const skSettleMerchantList = (code) => {
        (async _ => {
            return await settleMerchantListRequest({
                merchantCode: localStorage.appid,
                superMerchantCode: localStorage.appid,
            });
        })().then(res => {
            if (res.code == 0) {
                let index = res.data.findIndex((v) => { return v.merchantCode == localStorage.merchantCode })
                res.data.splice(index, 1)
                setShMerchantList(res.data)
            } else {

            }
        });
    }
    const expenseDelete = (row) => {
        (async _ => {
            return await expenseDeleteRequest({ id: row.id });
        })().then(res => {
            if (res.code == 0) {
            } else {
                message.error(res.msg)
            }
        });
    }
    const onFinish = (values) => {
        setParams(values)
        setDetailVisible(true)
    };
    const add = () => {
        navigate('/ws/bills/add')
    }


    const beforeUpload = (file) => {
        const isXlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        if (!isXlsx) {
            message.error('请上传excel表格!');
        }

        return isXlsx;
    }
    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            // setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            console.log(info.file.response.data);
            if (info.file.response.code == 0) {
                let arr = [];
                info.file.response.data.objects.map((v) => {
                    v.id = Math.random(10)
                    v.typeNames = [v.businessTypeNosNames]
                    v.businessTypeNosArry = [v.businessTypeNos]
                    v.payeeMerchantCodesArry = [v.payeeMerchantCodes]
                    if (v.expireType == 1 || v.expireType == 2) {
                        v.expireEndTime = null
                    }
                    if (!v.payeeMerchantCodesErrorMsg) {
                        arr.push(v)
                    }
                })
                console.log(arr.length)
                if (arr.length > 0) {
                    setArr([...arr])
                }

                // setLoading(false);
                setLists([...lists, ...info.file.response.data.objects])
                // setAipv(info.file.response.data.aipv.failCount)
            } else {
                message.error(info.file.response.msg)
            }

            // getBase64(info.file.originFileObj, (url) => {

            // });
        }
    };
    const onSave = async () => {
        const values = await form.validateFields();  //2.表单验证并获取表单值
        (async _ => {
            return await expenseOrderEditRequest({
                ...values,
                fundCostDetails: lists,
                superMerchantCode: localStorage.appid,
                operatorName: localStorage.operatorname,
                operatorId: localStorage.operatorId,
            });
        })().then(res => {
            if (res.code == 0) {
                message.success(res.msg)
                navigate(-1)
            } else {
                message.error(res.msg)
            }
        });
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(selectedRowKeys);
            setSelectedRowKeys(selectedRowKeys)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            console.log(record, selected, selectedRows, nativeEvent)
            record.checked = selected;
            console.log(record);
            let arr = []
            if (selected == false) {
                arr.push(record.orderNo)
            }
            setExcludeOrderNos(arr)

        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(selected);
            setSelectAll(selected)
        },
        onSelectNone: (a) => {
            console.log(a);
        },
        onSelectInvert: (selectedRowKeys) => {
            console.log(selectedRowKeys)
        },
        getCheckboxProps: (record) => ({
            // disabled: record.status !== 0,
        }),
        // getCheckboxProps: (record) => ({
        //     disabled: record.auditStatus !== 0,
        //     // Column configuration not to be checked
        //     name: record.name,
        // }),
    };
    const typeCancel = () => {
        setTypeVisible(false)
    }
    const amountCancel = () => {
        setAmountVisible(false)
    }
    return (
        <div style={{ background: '#ffffff', padding: 16, marginTop: 16 }}>


            <Form
                {...layout}
                form={form}
                onFinish={onFinish}
                initialValues={{
                    expenseStatus: null,
                    merchantCode: localStorage.merchantCode
                }}
                style={{ paddingBottom: 0 }}
            >
                <Title level={5}>基本信息</Title>
                <Form.Item
                    name="costName"
                    label="单据名称"
                    rules={[
                        {
                            required: true,
                            message: '请输入单据名称!',
                        },
                    ]}
                // style={{ marginLeft: 30 }}
                >
                    <Input style={{ width: 200 }} placeholder="请输入" />
                </Form.Item>
                <Form.Item
                    name="accountType"
                    label="支出账户"
                    rules={[
                        {
                            required: true,
                            message: '请选择支出账户!',
                        },
                    ]}
                // style={{ marginLeft: 30 }}
                >
                    <Select
                        disabled={lists.length > 0}
                        style={{ width: 200 }}
                        allowClear
                        placeholder="请选择">
                        <Option value="0">店铺余额-待结算</Option>
                        <Option value="4">钱包余额-待结算</Option>
                        <Option value="1">店铺余额</Option>
                        <Option value="2">钱包余额</Option>
                        <Option value="7">营销余额-待结算</Option>
                    </Select>
                </Form.Item>
                {
                    localStorage.hxState == 'true' ?


                        <Form.Item
                            style={{ marginTop: 26 }}

                            label="支出机构"
                            rules={[
                                {
                                    required: true,
                                    message: '请选择支出机构!',
                                },
                            ]}
                        >

                            <div style={{ display: 'flex', alignItems: 'center', width: 600, }}>
                                <Form.Item
                                    name="payerMerchantCodesArry"
                                    noStyle
                                >
                                    <Select placeholder="请选择支出机构！"
                                        disabled={lists.length > 0}
                                        mode="multiple"
                                        style={{ width: 400 }}
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.includes(input)}
                                        onChange={(e) => {
                                        }}
                                    >
                                        {
                                            merchantList && merchantList.map((v) => {
                                                return <Option rowKey={v.merchantCode} key={v.merchantCode} value={v.merchantCode}>{v.merchantName}</Option>
                                            })
                                        }

                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    // name="date"
                                    noStyle
                                >

                                    <Checkbox style={{ marginLeft: 10 }} onChange={(e) => {
                                        console.log(e.target.checked);
                                        if (e.target.checked) {
                                            let newArr = []
                                            merchantList.map((v) => {
                                                newArr.push(v.merchantCode)
                                            })
                                            form.setFieldsValue({
                                                payerMerchantCodesArry: newArr
                                            })
                                        } else {
                                            form.setFieldsValue({
                                                payerMerchantCodesArry: []
                                            })
                                        }
                                    }}>全选</Checkbox>
                                </Form.Item>
                            </div>


                        </Form.Item>
                        :
                        <Form.Item
                            label="机构名称"
                        >
                            {localStorage.merchantName}
                        </Form.Item>
                }

                <Title level={5}>分账规则</Title>
                <Row style={{ marginBottom: '-1.5vh', marginTop: 16 }}>
                    <Col span={12}>
                        <Form.Item
                            wrapperCol={{
                                offset: 0,
                                span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit" >
                                添加
                            </Button>
                            <Upload
                                name="excel"
                                accept=".xls, .xlsx"
                                // listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${host}/costRuleDetail/import`}
                                headers={{ 'token': localStorage.token, }}
                                beforeUpload={beforeUpload}
                                onChange={handleChange}
                                data={file => ({ // data里存放的是接口的请求参数
                                    superMerchantCode: localStorage.appid,
                                    accountType: form.getFieldValue().accountType,
                                    superMerchantCode: localStorage.appid,
                                    payerMerchantCodes: form.getFieldValue().payerMerchantCodesArry.toString()
                                })}
                            >
                                <Button style={{ marginLeft: 20 }}
                                // disabled={form.getFieldValue().accountType && form.getFieldValue().payerMerchantCodesArry}
                                >批量导入</Button>
                            </Upload>
                            <Button type="link" onClick={() => {
                                window.open(`${host}/excel/费用单导入模板.xlsx`)
                            }}>下载Excel模板</Button>
                        </Form.Item>

                    </Col>
                    <Col span={12} style={{ textAlign: 'right', }}>
                        <Select placeholder="请选择"
                            style={{ width: 250, textAlign: 'left' }}
                            // rowClassName={() => { getRowClassName() }} //改变某一行的背景颜色
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.includes(input)}
                            onChange={(e) => {
                                console.log(e);
                                if (e) {
                                    let itmp = {}
                                    let list = []
                                    list = lists.filter(item => {
                                        if (item.id === e) {
                                            itmp = item
                                        }
                                        return item.id !== e
                                    })
                                    list.unshift(itmp)
                                    setLists([...list])
                                }
                            }}

                        >

                            {
                                arr && arr.map((v) => {
                                    return <Option key={v.id} value={v.id}>{v.payeeMerchantNames}</Option>
                                })
                            }

                        </Select>
                    </Col>
                </Row>
                <Table
                    rowSelection={{
                        ...rowSelection,
                    }}
                    locale={{
                        emptyText: "没有更多数据了"
                    }}
                    style={{ marginTop: 20 }}
                    columns={columns}
                    dataSource={lists}
                    rowKey='id'
                    scroll={{
                        x: 1300,
                    }}
                    pagination={false}
                    footer={() => {
                        return (
                            <div>
                                <Popconfirm
                                    title="是否确认批量删除？"
                                    onConfirm={() => {
                                        selectedRowKeys.map((i) => {
                                            let index = lists.findIndex((v) => { return v.id == i })
                                            console.log(index);
                                            if (index != -1) {
                                                lists.splice(index, 1)
                                                arr.splice(index, 1)
                                                setLists([...lists])
                                                setArr([...arr])
                                            }

                                        })

                                    }}
                                    onCancel={() => {
                                        console.log('取消');
                                    }}
                                    okText="是"
                                    cancelText="否"
                                >
                                    <Button style={{ marginLeft: 0 }} disabled={selectedRowKeys.length == 0}>批量删除</Button>
                                </Popconfirm>

                                <Button style={{ marginLeft: 16 }}
                                    disabled={selectedRowKeys.length == 0}
                                    onClick={() => {
                                        setTypeVisible(true)
                                    }}
                                >收支类型</Button>
                                <Button style={{ marginLeft: 16 }} disabled={selectedRowKeys.length == 0}
                                    onClick={() => {
                                        setAmountVisible(true)
                                    }}
                                >单据金额</Button>
                            </div>

                        )
                    }}
                />
                <Row>
                    <Col span={24} style={{ textAlign: 'center', marginTop: 16 }}>
                        <Tooltip title={aipv > 0 ? "有错误数据，请先修改再提交" : ""} color='red'>
                            <Button type="primary"
                                // disabled={aipv > 0}
                                onClick={() => {
                                    onSave()
                                }}
                            >
                                保存
                            </Button>
                        </Tooltip>
                        <Popconfirm
                            title="是否确认清空?"
                            onConfirm={() => {
                                form.resetFields()
                                setLists([])
                            }}
                            onCancel={() => {
                                console.log('取消')
                            }}
                            okText="是"
                            cancelText="否"
                        >
                            <Button style={{ marginLeft: 16 }}
                            >
                                清空
                            </Button>
                        </Popconfirm>

                    </Col>
                </Row>
            </Form >


            <Modal
                title="分账规则"
                visible={detailVisible}
                onOk={detailHandleOk}
                onCancel={detailhandleCancel}
                width={600}
                footer={null}
                getContainer={false}  //1.排除警告
            >
                <SubLedgerRule data={params} accountType={form.getFieldValue().accountType} callback={(state) => {
                    console.log(state)
                    let a = state;
                    let newArr = [state]
                    let jigouArr = []
                    let index = lists.findIndex((v) => { return v.id == state.id })
                    if (index != -1) {
                        lists[index] = state
                        setLists([...lists])
                    } else {
                        console.log(1111111)
                        a.payeeMerchantNames = a.payeeMerchantNames.toString()
                        jigouArr.push(a)


                        setArr([...arr, ...jigouArr])
                        setLists([...lists, ...newArr])
                    }
                }}
                    closeDialog={() => {
                        setDetailVisible(false)
                    }} />
            </Modal>
            <Modal
                title="批量修改收支类型"
                visible={typeVisible}
                onCancel={typeCancel}
                width={400}
                footer={null}
                getContainer={false}  //1.排除警告
            >
                <Type
                    closeDialog={() => {
                        setTypeVisible(false)
                    }}
                    callback={(state) => {
                        console.log(state)
                        lists.map((v) => {
                            if (v.shareType == 0 && v.expenseReceiptType != 2 && v.expenseReceiptType != 3) {
                                v.expenseReceiptType = state.expenseReceiptType
                            }

                        })
                        setLists([...lists])
                        message.success('批量修改成功！')
                    }}
                />
            </Modal>
            <Modal
                title="批量修改单据金额"
                visible={amountVisible}
                onCancel={amountCancel}
                width={400}
                footer={null}
                getContainer={false}  //1.排除警告
            >
                <Amount
                    closeDialog={() => {
                        setAmountVisible(false)
                    }}
                    callback={(state) => {
                        console.log(state)
                        lists.map((v) => {
                            if (v.expenseReceiptType != 2 && v.expenseReceiptType != 3) {
                                v.expensePaySectionJson = state.expensePaySectionJson
                            }

                        })
                        setLists([...lists])
                        message.success('批量修改成功！')
                    }}
                />
            </Modal>
        </div >
    )
}
export default CostAdd;